/** @format */

export default {
    methods: {
        updateDocumentTitle(value) {
            if (value && !this._routeLeave) {
                document.title = value.substring(0, 155);
            }
        },
        updateMetaDescription(value) {
            if (value && !this._routeLeave) {
                let meta = document.querySelector('meta[name="description"]');
                if (!meta) {
                    meta = document.createElement('meta');
                    meta.setAttribute('name', 'description');
                    document.head.appendChild(meta);
                }
                meta.setAttribute('content', value.substring(0, 155));
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        // empty the meta description if navigating away
        this.updateMetaDescription('');
        next();
        this._routeLeave = true;
    },
};
